import React from 'react';
import icon1 from "../asset/expert.png"
import icon2 from "../asset/professional.png"
import icon3 from "../asset/experience.png"

const Card = () => {
  return (
    <div className="container mt-5 px-4 lg:px-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12">
        
      <div className="col-md-4 md:items-center md:justify-center aos-init aos-animate" data-aos="flip-right">
          <div className="card cardGroup__1 border-white shadow-custom hover:shadow-2xl text-center rounded-xl">
            <div className="flex items-center justify-center"> {/* Center the image */}
              <img
                className="w-1/3 h-1/3 pt-4" // Adjust the size of the image
                src={icon2}
                alt="professional exporter"
              />
            </div>
            <div className="card-body m-5 p-5">
              <h4 className="card-title text-black font-bold text-2xl font-EBGaramond">Professional</h4>
              <p className="card-text text-center font-semibold font-Montserrat">
              We only offer you the highest quality product, processed with strict quality control.    </p>
            </div>
          </div>
        </div>
        
      <div className="col-md-4 md:items-center md:justify-center aos-init aos-animate" data-aos="flip-right">
          <div className="card cardGroup__1 shadow-custom hover:shadow-2xl text-center rounded-xl">
            <div className="flex items-center justify-center"> {/* Center the image */}
              <img
                className="w-1/3 h-1/3 pt-4" // Adjust the size of the image
                src={icon1}
                alt="export expert"
              />
            </div>
            <div className="card-body m-5 p-5">
              <h4 className="card-title text-black font-bold text-2xl font-EBGaramond">Expert</h4>
              <p className="card-text text-center font-semibold font-Montserrat">
              We always prioritize professionalism in doing business, both to fishermen and customers. Our professionalism is to provide the best service and products, besides that we also do the work on time so that it can satisfy all parties   </p>
            </div>
          </div>
        </div>
        
    




        <div className="col-md-4 md:items-center md:justify-center aos-init aos-animate" data-aos="flip-right">
          <div className="card cardGroup__1 shadow-custom hover:shadow-2xl text-center rounded-xl">
            <div className="flex items-center justify-center"> {/* Center the image */}
              <img
                className="w-1/3 h-1/3 pt-4" // Adjust the size of the image
                src={icon3}
                alt="experienced exporter"
              />
            </div>
            <div className="card-body m-5 p-5">
              <h4 className="card-title text-black font-bold text-2xl font-EBGaramond">Experienced</h4>
              <p className="card-text text-center font-semibold font-Montserrat">
              Competitive prices with effective and efficient shipping costs </p>
            </div>
          </div>
        </div>


        
      </div>
    </div>
  );
};

export default Card;